import React, { useState, useEffect, useCallback } from "react";
import PlasticBottle from "./plastic-bottle.png";
import { getDocs, collection, updateDoc, doc } from "@firebase/firestore";
import { db } from "./firebase-config";
import "./BottleColl.css";
import { useLocation } from "react-router";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { Link } from "react-router-dom";
import RewardImg from "./reward.svg"

function BottleColl(props) {
  const [bottles, setBottles] = useState(0);
  const [points, setPoints] = useState();
  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    Autoplay({ delay: 4000 }),
  ]);

  console.log(props.Buid);
  console.log(props.Doc);
  return (
    <div>
      <div>
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            <div className="embla__slide">
              <div
                style={{
                  width: "75%",
                  margin: "0 auto",
                  color: "white",
                  fontSize: "20px",
                }}
              >
                <h1>
                  Ever thought about making a difference with each bottle? 🤔
                  Start Collecting Today for a Greener Tomorrow! 🌱 🌍🌍
                </h1>
                <Link to='/awarness'><button className="btn-al">Be Aware</button></Link>
              </div>
            </div>
            <div className="embla__slide">
              <div
                style={{
                  width: "75%",
                  margin: "0 auto",
                  color: "black",
                  fontSize: "20px",
                }}
              >
                <h1>
                  Curious to learn more? Dive into the world of bottle
                  collection and discover how your small actions can create a
                  big impact. 🚀🚀🚀💡💡♻️♻️
                </h1>
                <button className="btn-sl">Collect Bottles</button>
              </div>
            </div>
            <div className="embla__slide">
              <div
                style={{
                  width: "50%",
                  margin: "0 auto",
                  color: "black",
                  fontSize: "20px",
                  position: "relative",
                  left: "250px",
                }}
              >
                <h1>
                  Earn mindblowing rewards, cash prizes and many more for
                  collecting bottles 🚀🏆🏆🏆🥳🥳
                </h1>
                <button className="btn-sl">Earn Rewards</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="b-cont">
        <img
          className="b-img"
          src="https://media.licdn.com/dms/image/C5112AQHLSNNkaCj5RQ/article-cover_image-shrink_600_2000/0/1579528177058?e=2147483647&v=beta&t=QYI7X_dJ179jeCTuj0td62xWq1d4cyuMUtf4qe7EPHE"
        />
        <div
          style={{
            fontSize: "30px",
            backgroundColor: "#DEFDE0",
            position: "absolute",
            right: 0,
            height: "90vh",
            width: "50%",
          }}
        >
          <h1 className="lf-pnt" style={{ position: "relative", top: "90px" }}>
            LifeTime Points 🏆🪙: {props.Doc?.lpoints}
          </h1>
          <h1
            className="cr-pnts"
            style={{ position: "relative", top: "100px" }}
          >
            Current Points 🪙🪙 : {props.Doc?.cpoints}
          </h1>
          <div className="rcb">
            <div style={{ width: "50%" }}>
              <h3>Want to earn rewards and cash prizes</h3>
              <button className="btn-l">Earn the Rewards</button>
            </div>
            <div style={{ width: "50%", position: "absolute", left: "350px" }}>
              <h3>Collect bottles Now!!!</h3>
              <button className="btn-l">Collect Bottles</button>
            </div>
          </div>
        </div>
      </div>
      <div className="reward-box">
        <img
          className="b-img"
          src={RewardImg}
        />
        <div style={{display:'flex', flexDirection:'column', backgroundColor:'#f6eac2', width:'50%'}}>
          <h1>Redeem 🥳✨🎉🎊</h1>
          <button>Cash Redemption 💵</button>
          <button>Gift Voucher 🎁</button>
          <button>Donate To Charity 💝</button>
        </div>
      </div>
    </div>
  );
}

export default BottleColl;
